import { InfoCircledIcon, Pencil2Icon } from "@radix-ui/react-icons";
import { BubbleTone } from "components/IconBubble";
import SectionTitle from "components/SectionTitle";
import { Dialog } from "components/Dialog";
import { DialogTrigger } from "@radix-ui/react-dialog";
import { Button, ButtonSize } from "components/Button";
import { PlusIcon } from "@radix-ui/react-icons";
import { getButtonRoleColor } from "util/contextColor";
import NewNoteDialog from "components/Dashboard/NewNoteDialog";
import NotesDialog from "components/Dashboard/NotesDialog";
import {
  Auth0AccountRole,
  ParentLimitedResponse,
  NoteResponse,
  StudentLimitedResponse,
} from "client/openapi";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/Tooltip";
import "../index.css";
import { useContext, useState } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";

export default function Notes({
  title,
  parent,
  student,
  toolTipMessage,
}: {
  title: string;
  parent?: ParentLimitedResponse;
  student?: StudentLimitedResponse;
  toolTipMessage?: string;
}) {
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);
  const [newNoteOpen, setNewNoteOpen] = useState<boolean>(false);
  const [notes, setNotes] = useState<NoteResponse[]>([]);

  return (
    <section className="profile-box--section" id="parent-notes">
      <div className="profile-box--section-header pt-10">
        <div className="flex flex-row items-center">
          <SectionTitle icon={<Pencil2Icon />} tone={BubbleTone.ORANGE}>
            {title}
          </SectionTitle>
          {toolTipMessage && (
            <div className="ml-2 mr-2">
              <Tooltip>
                <TooltipTrigger>
                  <InfoCircledIcon className="w-5 h-5 text-gray-400" />
                </TooltipTrigger>
                <TooltipContent>{toolTipMessage}</TooltipContent>
              </Tooltip>
            </div>
          )}
        </div>

        <Dialog open={newNoteOpen}>
          <DialogTrigger asChild>
            <Button
              color={getButtonRoleColor(
                currently_selected_role
                  ? currently_selected_role
                  : Auth0AccountRole.ME
              )}
              size={ButtonSize.SMALL}
              onClick={() => setNewNoteOpen(true)}
            >
              Add Note <PlusIcon />
            </Button>
          </DialogTrigger>

          <NewNoteDialog
            role={currently_selected_role ? currently_selected_role : null}
            authorType={
              currently_selected_role === Auth0AccountRole.ORG_ADMIN
                ? Auth0AccountRole.ORG_ADMIN
                : Auth0AccountRole.ORG_TUTOR
            }
            parent_recipient={parent}
            student_recipient={student}
            setOpen={() => setNewNoteOpen(false)}
            notes={notes}
            setNotes={setNotes}
          />
        </Dialog>
      </div>

      <div className="profile-box--section-items">
        <div className="profile-box--section-item">
          <NotesDialog
            role={currently_selected_role ? currently_selected_role : null}
            parent_recipient={parent}
            student_recipient={student}
            notes={notes}
            setNotes={setNotes}
          />
        </div>
      </div>
    </section>
  );
}
